/*
 * @Author: Zhouqi
 * @Date: 2025-12-18 18:34:45
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-23 13:42:31
 */
import { message } from 'antd';

import { imageVerify as imageVerifyFn } from '@/services/common/imageVerify';
import { FaceSwapErrorCode } from '@/services/faceSwapper';
import { GetFileMD5 } from '@/utils/fileUtil';
import { t } from '@/utils/helper/intl';

import { textComplianceReview } from '../../service';

export const NegativePromptSuffix =
  '同时必须额外禁止以下效果：色调艳丽，过曝，静态，细节模糊不清，字幕，风格，作品，画作，画面，静止，整体发灰，最差质量，低质量，JPEG压缩残留，丑陋的，残缺的，多余的手指，画得不好的手部，画得不好的脸部，畸形的，毁容的，形态畸形的肢体，手指融合，静止不动的画面，杂乱的背景，三条腿，背景人很多，倒着走';

export async function handleTextVerify(text: string) {
  try {
    const result = await textComplianceReview(text);
    if (result.success && result?.data?.reviewState !== 1) {
      message.error(t('The text content is not compliant'));
      return false;
    }
    return true;
  } catch (error) {
    message.error(t('Text content compliance check failed'));
    console.error('文件合规检查catch', error);
    return false;
  }
}

export const DefaultAvatarPrompt =
  'The characters in the picture are explaining a product, with natural gestures and rich expressions';

export const handleImageVerify = (file: File, url: string): Promise<boolean> => {
  return new Promise(async (resolve, reject) => {
    const md5Image = (await GetFileMD5(file)) as string;

    const res = await imageVerifyFn({
      url,
      imageMd5: md5Image,
    });

    if (!res.success) {
      reject({ code: FaceSwapErrorCode.image_verify_failed });
      return;
    }

    if (res.data?.reviewState !== 1) {
      message.error(t('merror.swap.tip.pictureNotCompliantPleaseReselect'));
      reject({ code: FaceSwapErrorCode.image_verify_failed });
      return;
    }

    resolve(true);
  });
};
